module.exports = __webpack_public_path__ + "img/11.49d0819.png";